import moment from "moment/moment";
import getConfigEnumText from "src/common/utils/config/configEnumText";
import { ACCOUNT_USAGE_VISIBLE_UNITS_ENUM } from "src/features/auth/config/accountUsages";
const convertTranscriptsUsages = ({ ceiling, currentUsage, unitVisible: convertTo }) => {
    const duration = ceiling - currentUsage;
    return `${parseFloat(moment.duration(duration * 1000).asMinutes()).toFixed()} ${getConfigEnumText(ACCOUNT_USAGE_VISIBLE_UNITS_ENUM, convertTo)}`;
};
export default convertTranscriptsUsages;
